import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusOutgoing = () => {
  return (
    <SettingsMetaData propertyName={"Status_Outgoing"} viewPropertyName={"Status"} />
  );
};
export default StatusOutgoing;